/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadWaitlistRankRequest
 */
export interface UpdateLeadWaitlistRankRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateLeadWaitlistRankRequest
     */
    current_rank?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLeadWaitlistRankRequest
     */
    new_rank?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadWaitlistRankRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the UpdateLeadWaitlistRankRequest interface.
 */
export function instanceOfUpdateLeadWaitlistRankRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateLeadWaitlistRankRequestFromJSON(json: any): UpdateLeadWaitlistRankRequest {
    return UpdateLeadWaitlistRankRequestFromJSONTyped(json, false);
}

export function UpdateLeadWaitlistRankRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadWaitlistRankRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'current_rank': !exists(json, 'current_rank') ? undefined : json['current_rank'],
        'new_rank': !exists(json, 'new_rank') ? undefined : json['new_rank'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function UpdateLeadWaitlistRankRequestToJSON(value?: UpdateLeadWaitlistRankRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_rank': value.current_rank,
        'new_rank': value.new_rank,
        'comment': value.comment,
    };
}

